
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      chosenBanner: "" as string | FormData,
      chosenBannerCategory: "" as string | FormData,
      editImageFile: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
      dialog: false,
      imageSelected: "",
      imageSelectedValue: "",
      categoryTypes: [
        {
          title: "محصول",
          value: "product",
        },
        {
          title: "گرده آلومینیوم",
          value: "aluminium",
        },
        {
          title: "درب پیرکس",
          value: "potlid",
        },
      ],
    };
  },
  methods: {
    submitProduct() {
      // const data = store.state.admin.landing.categoryData;
      store.dispatch("admin/createLandingCategory", {
        image: this.chosenFile,
        banner: this.chosenBanner,
      });
    },
    submitBannerCategory() {
      store.dispatch("admin/submitBannerCategory", {
        image: this.chosenBannerCategory,
        category: this.category,
      });
    },
    submitSubCategory() {
      store.dispatch("admin/createNewSubCategory");
    },
    submitAluminiumCategory() {
      store.dispatch("admin/submitAluminiumCategory");
    },
    submitPotlidCategory() {
      store.dispatch("admin/submitPotlidCategory");
    },
    uploadImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch("admin/updateCategoryImage", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    editImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateCategoryImageEdit",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.editImageFile = formData;
      }
    },
    uploadBanner(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch("admin/updateCategoryBanner", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenBanner = formData;
      }
    },
    uploadBannerCategory(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch("admin/updateBannerCategory", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenBannerCategory = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },

    deleteCategory(id: string): void {
      store.dispatch("admin/deleteLandingCategory", id);
    },

    deleteService(id: string): void {
      store.dispatch("admin/deleteCategoryService", id);
    },

    deleteSubCategory(id: string): void {
      store.dispatch("admin/deleteSubCategory", id);
    },

    banner(image: string) {
      if (image !== "") {
        return this.url + image;
      } else {
        return this.defaultImage;
      }
    },

    openDialog(box: any): void {
      this.imageSelected = this.url + box.img;
      this.imageSelectedValue = box.value;
      this.dialog = true;
    },

    editCategoryImage() {
      const id = this.imageSelectedValue;
      const image = this.editImageFile;
      store.dispatch("admin/submitImageCategoryEdit", { id, image });
    },
  },

  watch: {
    category: {
      handler: function () {
        store.dispatch("admin/getServicesById", this.category);
      },
    },
  },

  computed: {
    categories(): any[] {
      const categories = store.state.admin.landing.categories;
      let items: any[] = [];
      categories.forEach((category: any) => {
        const item = {
          title: category.persianTitle,
          img: category.img,
          value: category._id,
        };
        items.push(item);
      });
      return items;
    },

    subCategories() {
      return store.state.admin.landing.subCategories;
    },

    categoryServices() {
      return store.state.admin.landing.categoryServices;
    },
    types(): any[] {
      const types = store.state.admin.landing.types;
      let items: any[] = [];
      types.forEach((category: any) => {
        const item = {
          title: category.title,
          value: category._id,
        };
        items.push(item);
      });
      return items;
    },
    persianTitle: {
      get(): string {
        return store.state.admin.landing.categoryData.persianTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateCategoryPersianTitle", value);
      },
    },
    persianTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.persianTitle?.$dirty) {
        return errors;
      }
      !this.$v.persianTitle.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    subCategoryPersianTitle: {
      get(): string {
        return store.state.admin.landing.subCategoryData.persianTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateSubCategoryPersianTitle", value);
      },
    },
    subCategoryPersianTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.subCategoryPersianTitle?.$dirty) {
        return errors;
      }
      !this.$v.subCategoryPersianTitle.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    subCategoryEnglishTitle: {
      get(): string {
        return store.state.admin.landing.subCategoryData.englishTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateSubCategoryEnglishTitle", value);
      },
    },
    subCategoryEnglishTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.subCategoryEnglishTitle?.$dirty) {
        return errors;
      }
      !this.$v.subCategoryEnglishTitle.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    subCategoryArabicTitle: {
      get(): string {
        return store.state.admin.landing.subCategoryData.arabicTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateSubCategoryArabicTitle", value);
      },
    },
    subCategoryArabicTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.subCategoryArabicTitle?.$dirty) {
        return errors;
      }
      !this.$v.subCategoryArabicTitle.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    categoryType: {
      get(): string {
        return store.state.admin.landing.categoryData.categoryType;
      },
      set(value: string): void {
        store.dispatch("admin/updateCategoryType", value);
      },
    },
    categoryTypeError(): string[] {
      const errors: string[] = [];
      if (!this.$v.categoryType?.$dirty) {
        return errors;
      }
      !this.$v.categoryType.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    englishTitle: {
      get(): string {
        return store.state.admin.landing.categoryData.englishTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateCategoryEnglishTitle", value);
      },
    },
    englishTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.englishTitle?.$dirty) {
        return errors;
      }
      !this.$v.englishTitle.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    arabicTitle: {
      get(): string {
        return store.state.admin.landing.categoryData.arabicTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateCategoryArabicTitle", value);
      },
    },
    arabicTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.arabicTitle?.$dirty) {
        return errors;
      }
      !this.$v.arabicTitle.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    description: {
      get(): string {
        return store.state.admin.landing.categoryData.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateCategoryDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    category: {
      get(): string {
        return store.state.admin.landing.productData.category;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingProductCategory", value);
      },
    },
    categoryError(): string[] {
      const errors: string[] = [];
      if (!this.$v.category?.$dirty) {
        return errors;
      }
      !this.$v.category.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    subCategoryCategory: {
      get(): string {
        return store.state.admin.landing.subCategoryData.category;
      },
      set(value: string): void {
        store.dispatch("admin/updateLandingSubCategory", value);
      },
    },
    subCategoryCategoryError(): string[] {
      const errors: string[] = [];
      if (!this.$v.subCategoryCategory?.$dirty) {
        return errors;
      }
      !this.$v.subCategoryCategory.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    aluminiumTitle: {
      get(): string {
        return store.state.admin.landing.aluminiumCategory.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateAluminiumTitle", value);
      },
    },

    aluminiumTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.aluminiumTitle?.$dirty) {
        return errors;
      }
      !this.$v.aluminiumTitle.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    aluminiumLanguage: {
      get(): string {
        return store.state.admin.landing.aluminiumCategory.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateAluminiumLanguage", value);
      },
    },
    aluminiumLanguageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.aluminiumLanguage?.$dirty) {
        return errors;
      }
      !this.$v.aluminiumLanguage.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    potlidTitle: {
      get(): string {
        return store.state.admin.landing.potlidCategory.title;
      },
      set(value: string): void {
        store.dispatch("admin/updatePotlidTitle", value);
      },
    },

    potlidTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.potlidTitle?.$dirty) {
        return errors;
      }
      !this.$v.potlidTitle.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    potlidLanguage: {
      get(): string {
        return store.state.admin.landing.potlidCategory.language;
      },
      set(value: any): void {
        store.dispatch("admin/updatePotlidLanguage", value);
      },
    },
    potlidLanguageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.potlidLanguage?.$dirty) {
        return errors;
      }
      !this.$v.potlidLanguage.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    isLoading(): boolean {
      return store.state.app.loading;
    },
  },

  created() {
    store.dispatch("admin/getAllCategories");
    store.dispatch("admin/getLandingSubCategories");
  },

  validations: {
    aluminiumTitle: {
      required,
    },
    aluminiumLanguage: {
      required,
    },
    potlidTitle: {
      required,
    },
    potlidLanguage: {
      required,
    },
    category: {
      required,
    },
    subCategoryCategory: {
      required,
    },
    persianTitle: {
      required,
    },
    subCategoryPersianTitle: {
      required,
    },
    subCategoryEnglishTitle: {
      required,
    },
    subCategoryArabicTitle: {
      required,
    },
    categoryType: {
      required,
    },
    englishTitle: {
      required,
    },
    arabicTitle: {
      required,
    },
    description: {
      required,
    },
  },
});
